import {
  i
} from "./chunk.775UL347.js";

// src/components/jb-date/jb-date.css.ts
var jb_date_css_default = i`time{font-family:var(--theme-font-light-family, VerlagSSmforBaerVar, Tahoma, sans-serif);font-style:normal;font-weight:var(--theme-font-light-weight, 300)}time{font-size:var(--theme-typo-body-sm-desktop-fontsize, 0.813rem);font-weight:var(--theme-typo-body-sm-fontweight, var(--theme-font-light-weight, 300));line-height:var(--theme-typo-body-sm-desktop-lineheight, 1.25rem)}.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}time{display:flex;gap:var(--gap, 4px);opacity:var(--text-opacity, 1)}`;

export {
  jb_date_css_default
};
